
<template>
	<div class="hello">
		<div class="header">
			<van-nav-bar title="" left-arrow>
			  <template #right>
				  <van-icon name="ellipsis" />
			  </template>
			</van-nav-bar>
			<img src="../assets/topback.png" style="width: 190px;height: 146px;float: right;" alt="">
			<div>
				<h2><span>充</span>值状态确认</h2>
			</div>
		</div>
		<div class="center" style="position: relative;">
				<div class="center-top">
					<div class="top_content">
						<div class="bt">
							<img src="../assets/water.png" >
							<span>水费</span>
							<p>{{trans.projectName}}</p>
						</div>

						<div class="top">
							<div class="top_t">
								<span>订单状态：</span>
								<span class="sz" v-if="trans.status == 0">待支付</span>
								<span class="sz" v-else-if="trans.status == 1">支付成功</span>
								<span class="sz" v-else-if="trans.status == 2">充值成功</span>
								<span class="sz" v-else-if="trans.status == 3">充值失败</span>
							</div>
							<div class="djs">
								<img src="../assets/djs.png" alt="">
								<p>充值预计到账时间所需5-10分钟</p>
							</div>
						</div>
						<div class="content">
							<p class="tran">订单信息</p>
							<div class="one"><span class="left">识别编码信息</span><span class="right">{{trans.houseHoldNumber}}</span></div>

							<div><span class="left">住址信息</span><span class="right">{{trans.devAddress}}</span></div>


							<div><span class="left">支付金额</span><span class="right">{{trans.price}}</span></div>

							<div><span class="left">实际充值金额</span><span class="right">{{trans.totalPrice}}</span></div>

							<div><span class="left">手续费</span><span class="right">{{trans.taxPrice}}</span></div>

							<div>
								<span class="left">支付方式</span>
							<span class="right" v-if="trans.payType == 1">微信支付</span>
							<span class="right" v-else-if="trans.payType == 2">支付宝支付</span>
							<span class="right" v-else-if="trans.payType == 3">现金支付</span>
							</div>

							<div><span class="left">充值时间</span><span class="right">{{trans.updateTime}}</span></div>

							<div><span class="left">交易单号</span><span class="right">{{trans.orderNo}}</span></div>

							<div><span class="left">商户单号</span><span class="right">{{trans.transactionNo}}</span></div>

							<div><span class="left">商户全称</span><span class="right">{{trans.mchName}}</span></div>

              <van-button type="primary" @click="goJump" style="width: 100%;margin: 10px auto;background-color: #2D86F6;height:40px;border-radius: 10px;letter-spacing: 5px;">
                <span style="font-size: 15px;">返回首页</span>
              </van-button>
						</div>
					</div>
				</div>
		</div>

	</div>
</template>

<script>
	import axios from "axios"
	export default{
		data(){
			return{
				trans:[]
			}
		},
		mounted() {
			var config = {
			  method: 'get',
			//   url: 'https://h5.hzjf.top/prod-api/api/order/list',
			  url: 'https://jrhh5.whjrh.top/prod-api/api/order/list',
			  headers: { 
			    'Authorization': 'Bearer '+this.$cookies.get("token")
			  },
			params:{
				orderNo:this.$route.query.orderNo
			}
			};

			axios(config)
			.then((response)=>{
				console.log(response)
				this.trans = response.data.data.items[0]

			})
		},
		methods:{
      goJump(){
        this.$router.push({
          path: "/index",
        })
      },
		}
	}
</script>

<style scoped>
	.clear{
		clear: both;
	}
	.header{
		width: 100%;
		height: 192px;
		background-color: #295ad0;
	}

	.header h2{
		letter-spacing:2px;
		color: rgb(255, 255, 255);
		line-height: 120px;
		position: relative;
		margin-left:20px
	}
	.header h2 span{
		border-bottom: 3px solid #fff;
	}
	.center{
		width: 90%;
		margin: 0 auto;
		height:800px;
		border:1px solid #dee1e5;
		box-shadow: #dee1e5 0px 0px 1px 1px;
		margin-top:-15px;
		border-radius: 10px;
		background-color: #fff;
	}
	.center-top{
		width: 80%;
		margin: 0 auto;
	}
	.djs{
		text-align: center;
		margin-top: 40px;
		border-bottom: 1px solid #dee1e5;
	}
	.djs img{
		width: 28px;
		height: 36px;

	}
	.djs p{
		color: #000000;
	}
	.sz{
		color:#0F72DD ;
	}
	.top{
		margin-top:35px
	}
	.bt{
		margin-top:20px
	}

	.bt img{
		width: 38px;
		height:38px;
		float: left;
	}
	.bt span{
		line-height: 42px;
		margin-left: 10px;
		font-size: 20px;
	}
	.bt p {
		color:#0F72DD;
	}
	.content{
		margin-top: 20px;
	}
	.content .tran{
		color:#0F72DD;
		margin-bottom: 35px;
	}

	.content div{
		height:40px
	}
	.content div span{
		font-size: 10px;
	}
	.content div .left{
		color: #8e8e8e;
		float: left;
	}
	.content div .right{
		float: right;
	}
</style>
